/**
 * Evita que Enter en inputs/select dispare el submit del formulario.
 * Opcionalmente ejecuta una acción cuando Enter se pulsa dentro de [data-enter-action-zone].
 */
export function handlePreventEnterFormSubmit(e, { onEnterInZone } = {}) {
  if (e.key !== 'Enter' || e.defaultPrevented) return;
  if (e.nativeEvent?.isComposing) return;

  const target = e.target;
  if (!target?.tagName) return;

  if (target.tagName === 'TEXTAREA') return;
  if (target.tagName === 'BUTTON' && target.type === 'submit') return;

  const actionZone = target.closest?.('[data-enter-action-zone]');
  if (actionZone && typeof onEnterInZone === 'function') {
    e.preventDefault();
    onEnterInZone(e, actionZone);
    return;
  }

  if (target.tagName === 'INPUT' || target.tagName === 'SELECT') {
    e.preventDefault();
  }
}
